// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*purgecss start ignore*/\n.vue-street-view-pano-container{\n  position:relative\n}\n.vue-street-view-pano-container .vue-street-view-pano{\n  left:0;\n  right:0;\n  top:0;\n  bottom:0;\n  position:absolute\n}\n\n/*purgecss end ignore*/", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
